module.exports = __webpack_public_path__ + "img/hc_pro_seven_2.7a52374a.jpg";